/**
 * ef-064-8 anchor (Spec Architect, FROZEN) - the one unit vocabulary of a register line's quantity (`entry_line.unit`, 0095): the
 * eight grain units plus `head` (rescope D6). Mirrors `RegisterQuantityUnits.Allowed` (EasyFarm.Api.Demo) word for word, in the same
 * order. Any line may carry any unit; the screen offers all nine everywhere.
 */
export const REGISTER_QUANTITY_UNITS = ["bu", "ton", "cwt", "lb", "piece", "bag", "carton", "lint_lb", "head"] as const;

export type RegisterQuantityUnit = (typeof REGISTER_QUANTITY_UNITS)[number];

/** Largest quantity the server holds (`numeric(14,3)`); more is a 400 naming `quantity`. */
export const MAX_REGISTER_QUANTITY = 99_999_999_999.999;

const quantityFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 });

/**
 * "1,000.5 bu" - how a quantity is spelled on the register row and in the ledger's Qty column: en-US grouping, up to 3 decimals and
 * no trailing zeros, one space, then the unit word as stored. Display only: nothing computes with a quantity on the client.
 */
export function formatQuantity(quantity: number, unit: string): string {
  return `${quantityFormatter.format(quantity)} ${unit}`;
}
